
import { Checkbox, Group } from "@mantine/core";
import { Controller, useFormContext } from "react-hook-form";

const RHFCheckboxGroup = ({
  name,
  rules,
  defaultValue = [],
  options = [],
  data = [],
  orientation = "horizontal",
  gap = "lg",
  onValueChange,
  ...props
}) => {
  const { control } = useFormContext();

  const checkboxItems = options.length > 0 ? options : data;

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error } }) => (
        <Checkbox.Group
          {...props}
          name={field.name}
          value={Array.isArray(field.value) ? field.value : []}
          error={error?.message}
          onChange={(value) => {
            field.onChange(value);

            if (onValueChange) {
              onValueChange(value);
            }
          }}
        >
          <Group
            gap={gap}
            align="center"
            style={{
              flexDirection:
                orientation === "vertical" ? "column" : "row",
            }}
          >
            {checkboxItems.map((item) => (
              <Checkbox
                key={item.value}
                value={item.value}
                label={item.label}
                color="blue"
                size="xs"
                    disabled={item.disabled}
                     styles={{
    body: {
      padding: "14px 24px 14px 16px",
      backgroundColor: "#e8eef7",
      borderRadius: "26px",
    },
  }}
              />
            ))}
          </Group>
        </Checkbox.Group>
      )}
    />
  );
};

export default RHFCheckboxGroup;
